var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarksPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.27,62.72h33.29a0,0,0,0,1,0,0v53.07a0,0,0,0,1,0,0H153.2a0,0,0,0,1,0,0v-49A4.07,4.07,0,0,1,157.27,62.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,69.3l-25.8-.11-75.35-.35-9.08,0-22.58-.11A20.27,20.27,0,0,0,51.45,88.85L50.07,413.59a20.27,20.27,0,0,0,20.21,20.33l132.81.61a20.27,20.27,0,0,0,20.39-20.16l1.38-324.74A20.28,20.28,0,0,0,204.65,69.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,116.36c0,.32-28,.57-62.64.57s-62.65-.25-62.65-.57,28-.58,62.65-.58S197.79,116,197.79,116.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.06,
    y: 132.11,
    width: 131.42,
    height: 8.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,166.73c0,.31-28,.57-62.64.57S72.5,167,72.5,166.73s28-.58,62.65-.58S197.79,166.41,197.79,166.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,182.73c0,.32-28,.57-62.64.57s-62.65-.25-62.65-.57,28-.58,62.65-.58S197.79,182.41,197.79,182.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,198.73c0,.32-28,.57-62.64.57s-62.65-.25-62.65-.57,28-.57,62.65-.57S197.79,198.41,197.79,198.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,214.73c0,.32-28,.58-62.64.58s-62.65-.26-62.65-.58,28-.57,62.65-.57S197.79,214.42,197.79,214.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,230.74c0,.31-28,.57-62.64.57s-62.65-.26-62.65-.57,28-.58,62.65-.58S197.79,230.42,197.79,230.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.59,248.88c0,.32-28.06.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S199.59,248.56,199.59,248.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.65,
    y: 278.44,
    width: 131.75,
    height: 127.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.82,316.64a9.48,9.48,0,1,1-9.48-9.48A9.48,9.48,0,0,1,161.82,316.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22,288.42l-111.31-.09c.12-.14-1.2,1.2-.64.65V303.4q0,7.17,0,14.19,0,14.06,0,27.47c0,17.85,0,34.73.06,50.25v.55h.55l80.84-.28,22.57-.14,5.92-.06,1.5,0a2.83,2.83,0,0,0,.49,0l-27-46.25-18.11,22.26L119.31,329.4,83.45,394.74c0-15.37,0-32.05.06-49.68q0-13.4,0-27.47,0-7,0-14.19V289.59l110.15-.09c.11,31.59.21,57.91.27,76.42.06,9.28.11,16.59.14,21.65,0,2.46,0,4.38.07,5.73,0,.62,0,1.11,0,1.49a3.69,3.69,0,0,0,0,.52,2.36,2.36,0,0,0,0-.46c0-.37,0-.83,0-1.43,0-1.33,0-3.21.06-5.63,0-5,.08-12.3.14-21.53.07-18.7.16-45.33.28-77.3v-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,68.19a5.46,5.46,0,0,0-5.46-5.47H159.73a5.45,5.45,0,0,1,5.46,5.45v53.25l19-10.69,19,9.74S203.06,82.61,203.12,68.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,82.64l1.32,2.68a.79.79,0,0,0,.57.42l3,.43a.76.76,0,0,1,.42,1.29l-2.14,2.08a.77.77,0,0,0-.22.67l.51,3a.76.76,0,0,1-1.1.8l-2.65-1.39a.73.73,0,0,0-.7,0L181.71,94a.75.75,0,0,1-1.09-.8l.5-3a.77.77,0,0,0-.22-.67l-2.14-2.08a.76.76,0,0,1,.42-1.29l3-.43a.78.78,0,0,0,.57-.42L184,82.64A.76.76,0,0,1,185.39,82.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,60.06h33.29a0,0,0,0,1,0,0v53.07a0,0,0,0,1,0,0H370.2a0,0,0,0,1,0,0v-49A4.07,4.07,0,0,1,374.27,60.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.65,66.65l-25.8-.12-75.36-.34-9.07,0L288.84,66a20.27,20.27,0,0,0-20.4,20.16l-1.38,324.74a20.28,20.28,0,0,0,20.21,20.33l132.81.61a20.27,20.27,0,0,0,20.4-20.16L441.85,87A20.26,20.26,0,0,0,421.65,66.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,113.71c0,.31-28.05.57-62.65.57s-62.65-.26-62.65-.57,28.05-.58,62.65-.58S414.79,113.39,414.79,113.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.06,
    y: 129.46,
    width: 131.42,
    height: 8.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,164.07c0,.32-28.05.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S414.79,163.75,414.79,164.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,180.07c0,.32-28.05.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S414.79,179.76,414.79,180.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,196.08c0,.31-28.05.57-62.65.57s-62.65-.26-62.65-.57,28.05-.58,62.65-.58S414.79,195.76,414.79,196.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,212.08c0,.32-28.05.57-62.65.57s-62.65-.25-62.65-.57,28.05-.58,62.65-.58S414.79,211.76,414.79,212.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,228.08c0,.32-28.05.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S414.79,227.76,414.79,228.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.58,246.23c0,.31-28.05.57-62.64.57s-62.66-.26-62.66-.57,28.05-.58,62.66-.58S416.58,245.91,416.58,246.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.65,
    y: 275.78,
    width: 131.75,
    height: 127.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.81,314a9.48,9.48,0,1,1-9.48-9.48A9.48,9.48,0,0,1,378.81,314Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.21,285.77l-111.31-.09-.64.64v28.62c0,9.36,0,18.54,0,27.46,0,17.86,0,34.73.06,50.26v.55h.54l80.84-.28,22.58-.15,5.91-.06,1.5,0a2.69,2.69,0,0,0,.49,0l-27-46.26-18.11,22.27L336.3,326.74l-35.86,65.34c0-15.36,0-32,.06-49.68,0-8.92,0-18.1,0-27.46v-28l110.15-.09c.12,31.59.21,57.92.28,76.43.06,9.28.11,16.59.14,21.64,0,2.47.05,4.38.06,5.74,0,.62,0,1.11,0,1.49a3.87,3.87,0,0,0,0,.52,2.49,2.49,0,0,0,0-.46c0-.37,0-.84,0-1.43,0-1.33,0-3.21.06-5.63,0-5,.09-12.3.14-21.53.07-18.7.17-45.33.28-77.3v-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.11,65.54a5.46,5.46,0,0,0-5.45-5.48H376.73a5.46,5.46,0,0,1,5.45,5.46v53.24l19-10.68,19,9.73S420.06,80,420.11,65.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.38,80l1.33,2.68a.74.74,0,0,0,.57.41l3,.43a.76.76,0,0,1,.42,1.29l-2.14,2.09a.75.75,0,0,0-.22.67l.5,3a.75.75,0,0,1-1.1.79l-2.64-1.39a.81.81,0,0,0-.71,0l-2.64,1.39a.75.75,0,0,1-1.1-.79l.5-3a.72.72,0,0,0-.21-.67l-2.14-2.09a.75.75,0,0,1,.42-1.29l2.95-.43a.74.74,0,0,0,.57-.41L401,80A.75.75,0,0,1,402.38,80Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.87,196.94l8.35-14.72a39.47,39.47,0,1,1,9.45,10.51v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.87,196.94l17.78-4.32-.07.21v0a.12.12,0,0,1,0-.18.12.12,0,0,1,.16,0,40.49,40.49,0,0,0,8.07,4.8,39.16,39.16,0,0,0,10.72,3,35,35,0,0,0,6.18.29c1.07-.06,2.15-.09,3.24-.19l3.29-.5a39.35,39.35,0,0,0,24.31-15.68,38.86,38.86,0,0,0,6.56-15.05,39.73,39.73,0,0,0-.47-17.3,38.4,38.4,0,0,0-8.34-16l-1.59-1.75c-.52-.59-1.14-1.07-1.71-1.61a23.36,23.36,0,0,0-1.76-1.54l-1.87-1.4a16.47,16.47,0,0,0-1.93-1.27l-2-1.2-2.07-1a16.66,16.66,0,0,0-2.08-.92,39.71,39.71,0,0,0-17.44-2.7,38.5,38.5,0,0,0-16,4.71,39.64,39.64,0,0,0-18.55,22.72,42.6,42.6,0,0,0-1.74,12.69,39.22,39.22,0,0,0,5.74,19.42.11.11,0,0,1,0,.12l-8.46,14.66,8.25-14.78v.13a39.19,39.19,0,0,1-5.89-19.54,42.76,42.76,0,0,1,1.71-12.82,40,40,0,0,1,18.7-23,38.89,38.89,0,0,1,16.22-4.8,40.13,40.13,0,0,1,17.66,2.72,16.55,16.55,0,0,1,2.11.94l2.1,1,2,1.22a16.87,16.87,0,0,1,1.95,1.29l1.89,1.42c.65.45,1.19,1,1.79,1.55s1.2,1,1.73,1.64l1.61,1.77a38.81,38.81,0,0,1,8.45,16.2,40.15,40.15,0,0,1,.46,17.53A39,39,0,0,1,454,184.63a39.66,39.66,0,0,1-24.62,15.81l-3.33.5c-1.1.09-2.19.12-3.27.18a34.66,34.66,0,0,1-6.24-.32,39.65,39.65,0,0,1-10.8-3.08,40.6,40.6,0,0,1-8.1-4.89l.18-.18,0,0a.13.13,0,0,1,0,.18l-.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,143H409.8a3.63,3.63,0,0,0-3.63,3.64c0,9.58,0,23.18,0,23.18l25.26-.37V146.6A3.63,3.63,0,0,1,435,143Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414,143H409.8a3.63,3.63,0,0,0-3.63,3.64c0,9.58,0,23.18,0,23.18l25.26-.37V146.6A3.63,3.63,0,0,1,435,143Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M438,146.6a3.61,3.61,0,0,0-3.62-3.63H409.12a3.62,3.62,0,0,1,3.63,3.63v33.65a1,1,0,0,0,1.53.89l11.11-6.24,11.13,5.7a1,1,0,0,0,1.49-.91C438,173.9,437.94,154.68,438,146.6Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.37,155.93l.92,1.87a.54.54,0,0,0,.4.29l2.07.3a.53.53,0,0,1,.29.9l-1.49,1.46a.52.52,0,0,0-.16.47l.36,2.06a.53.53,0,0,1-.77.56l-1.85-1a.53.53,0,0,0-.49,0l-1.85,1a.53.53,0,0,1-.77-.56l.35-2.06a.52.52,0,0,0-.15-.47l-1.5-1.46a.53.53,0,0,1,.3-.9l2.07-.3a.51.51,0,0,0,.39-.29l.93-1.87A.53.53,0,0,1,425.37,155.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207,29.4h33.29a0,0,0,0,1,0,0V82.47a0,0,0,0,1,0,0H203a0,0,0,0,1,0,0v-49A4.07,4.07,0,0,1,207,29.4Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207,29.4h33.33a0,0,0,0,1,0,0V82.47a0,0,0,0,1,0,0H203a0,0,0,0,1,0,0v-49A4,4,0,0,1,207,29.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,36l-25.8-.12-75.36-.35-9.07,0-22.58-.1a20.27,20.27,0,0,0-20.4,20.16L99.84,380.27a20.28,20.28,0,0,0,20.21,20.33l132.82.62a20.28,20.28,0,0,0,20.39-20.16l1.38-324.74A20.28,20.28,0,0,0,254.43,36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,36l.68,0,.84,0a7.62,7.62,0,0,1,1.16.12l1.48.23,1.77.46c.62.2,1.29.46,2,.73s1.45.64,2.19,1.11a20.29,20.29,0,0,1,4.56,3.59A19.41,19.41,0,0,1,273,48.13a20.31,20.31,0,0,1,1.71,8c0,2.92,0,6,0,9.33-.09,26.38-.23,64.55-.39,111.71s-.41,103.32-.65,165.67q0,11.69-.09,23.67,0,6-.05,12c0,1,0,2,0,3l-.09,1.54-.23,1.52a19.79,19.79,0,0,1-2,5.82,21.27,21.27,0,0,1-3.65,5,22.15,22.15,0,0,1-5,3.68,20.86,20.86,0,0,1-5.91,2l-1.56.23-1.57.08c-1,.05-2.09,0-3.13,0l-25.21-.12-105-.48a20.68,20.68,0,0,1-12.64-4.4,20.42,20.42,0,0,1-7.23-11.15,24.2,24.2,0,0,1-.62-6.66l0-6.64q0-6.61.06-13.19.1-26.28.22-51.76c.15-33.93.29-66.66.43-97.85s.27-60.81.4-88.54q.09-20.79.18-40.13,0-9.65.09-18.91c0-1.54,0-3.07,0-4.6,0-.76,0-1.52,0-2.29l.07-1.14c0-.38.11-.76.16-1.13A20.32,20.32,0,0,1,119,35.37a32.82,32.82,0,0,1,4.19-.16l4.13,0,8.08,0,30,.16,48.05.27,30.37.19,7.9.06,2.69,0H243.84l-30.37-.09-48.05-.18-30-.12-8.08,0h-4.12a30.26,30.26,0,0,0-4.15.16,20,20,0,0,0-17.39,16.8c0,.37-.13.74-.16,1.11l-.06,1.13c0,.74,0,1.51,0,2.27,0,1.53,0,3.06,0,4.6q0,9.25-.07,18.92-.07,19.31-.16,40.12c-.11,27.73-.23,57.36-.35,88.55s-.26,63.91-.4,97.85q-.1,25.44-.22,51.76,0,6.57,0,13.19,0,3.3,0,6.63a23.4,23.4,0,0,0,.61,6.53,19.83,19.83,0,0,0,7,10.87,20.16,20.16,0,0,0,12.32,4.29l105,.49,25.21.12c1,0,2.09,0,3.11,0l1.54-.08,1.52-.22a20.61,20.61,0,0,0,5.77-2,21.63,21.63,0,0,0,4.89-3.59,21,21,0,0,0,3.57-4.87,19.22,19.22,0,0,0,1.95-5.68l.23-1.48.08-1.5c.06-1,0-2,0-3l.06-12.05q0-12,.1-23.66c.29-62.36.54-118.51.76-165.67s.42-85.33.56-111.71c0-3.29,0-6.41,0-9.33a20.26,20.26,0,0,0-1.67-7.93A19.59,19.59,0,0,0,269,42.38a20.24,20.24,0,0,0-4.53-3.59c-.73-.47-1.49-.76-2.17-1.12s-1.37-.53-2-.74l-1.75-.46-1.47-.25a7.89,7.89,0,0,0-1.16-.13l-.84-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.84,
    y: 256.95,
    width: 131.42,
    height: 8.79,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,291.56c0,.32-28,.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S247.57,291.24,247.57,291.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,83c0,.32-28,.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S247.57,82.72,247.57,83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,307.56c0,.32-28,.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S247.57,307.25,247.57,307.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,323.57c0,.31-28,.57-62.65.57s-62.65-.26-62.65-.57,28.05-.58,62.65-.58S247.57,323.25,247.57,323.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,339.57c0,.32-28,.57-62.65.57s-62.65-.25-62.65-.57,28.05-.58,62.65-.58S247.57,339.25,247.57,339.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,355.57c0,.32-28,.58-62.65.58s-62.65-.26-62.65-.58,28.05-.57,62.65-.57S247.57,355.25,247.57,355.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,373.72c0,.31-28.05.57-62.64.57s-62.65-.26-62.65-.57,28-.58,62.65-.58S249.36,373.4,249.36,373.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.27,
    y: 101.29,
    width: 131.75,
    height: 127.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.44,139.49A9.48,9.48,0,1,1,202,130,9.48,9.48,0,0,1,211.44,139.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.84,111.27l-111.31-.09c.13-.14-1.2,1.2-.64.65v14.42q0,7.17,0,14.2c0,9.36,0,18.53,0,27.46,0,17.85.05,34.73.06,50.26v.55h.55l80.84-.27,22.58-.15,5.91-.06,1.5,0a2.69,2.69,0,0,0,.49,0l-27-46.26-18.12,22.27-29.81-41.93-35.86,65.34c0-15.37,0-32,.06-49.68,0-8.93,0-18.1,0-27.46q0-7,0-14.2V112.44l110.15-.09c.12,31.59.21,57.91.28,76.43.06,9.28.1,16.59.14,21.64,0,2.47,0,4.38.06,5.74,0,.62,0,1.1,0,1.48a4,4,0,0,0,0,.53,2.56,2.56,0,0,0,0-.47c0-.36,0-.83,0-1.42,0-1.34,0-3.21.06-5.64,0-5,.08-12.29.14-21.52.07-18.7.16-45.33.28-77.31v-.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252.89,34.88a5.46,5.46,0,0,0-5.45-5.48H209.51A5.45,5.45,0,0,1,215,34.86V88.1l19-10.68,19,9.73S252.84,49.29,252.89,34.88Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.17,49.32,236.49,52a.75.75,0,0,0,.57.42l3,.43a.76.76,0,0,1,.42,1.29l-2.14,2.09a.75.75,0,0,0-.22.67l.5,2.94a.75.75,0,0,1-1.09.8l-2.65-1.39a.75.75,0,0,0-.71,0l-2.64,1.39a.76.76,0,0,1-1.1-.8l.51-2.94a.75.75,0,0,0-.22-.67l-2.14-2.09a.76.76,0,0,1,.42-1.29l3-.43a.77.77,0,0,0,.57-.42l1.32-2.68A.76.76,0,0,1,235.17,49.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.81,479.11,193.26,479a28.44,28.44,0,0,1-28.42-28.44l.07-327.3a28.43,28.43,0,0,1,28.45-28.43l130.55.08a28.43,28.43,0,0,1,28.42,28.44l-.06,327.3A28.44,28.44,0,0,1,323.81,479.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.77,106.51H298.46a6.28,6.28,0,0,0-6.14,6.42v4.59a6.28,6.28,0,0,1-6.14,6.42l-49.34,0a6.31,6.31,0,0,1-6.15-6.43v-4.59a6.28,6.28,0,0,0-6.14-6.43H193.48a19.91,19.91,0,0,0-19.92,19.91l-.07,319.46a19.91,19.91,0,0,0,19.91,19.92l130.29.08a19.92,19.92,0,0,0,19.93-19.91l.06-319.47A19.93,19.93,0,0,0,323.77,106.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,439a2.51,2.51,0,1,1-2.52-2.48A2.5,2.5,0,0,1,249,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,438.89a2.5,2.5,0,1,1-2.52-2.48A2.52,2.52,0,0,1,263,438.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.51,
    cy: 438.8,
    r: 2.5,
    transform: "translate(-231.23 328.69) rotate(-45.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.74,
    y: 318.91,
    width: 121.05,
    height: 7.91,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,344.92c0,.28-27.18.52-60.69.52s-60.7-.24-60.7-.52,27.17-.52,60.7-.52S317.06,344.63,317.06,344.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,359.32c0,.28-27.18.51-60.69.51s-60.7-.23-60.7-.51,27.17-.52,60.7-.52S317.06,359,317.06,359.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,373.71c0,.29-27.18.52-60.69.52s-60.7-.23-60.7-.52,27.17-.51,60.7-.51S317.06,373.43,317.06,373.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,388.11c0,.28-27.18.52-60.69.52s-60.7-.24-60.7-.52,27.17-.52,60.7-.52S317.06,387.82,317.06,388.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,402.5c0,.29-27.18.52-60.69.52s-60.7-.23-60.7-.52,27.17-.51,60.7-.51S317.06,402.22,317.06,402.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.79,418.83c0,.28-27.17.51-60.68.51s-60.7-.23-60.7-.51,27.17-.52,60.7-.52S318.79,418.54,318.79,418.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.52,
    y: 181.39,
    width: 55.26,
    height: 53.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.92,197.42a4,4,0,1,1-4-4A4,4,0,0,1,233.92,197.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.51,185.58l-46.69,0-.27.28h0v6c0,2,0,4,0,6v11.52c0,7.49,0,14.57,0,21.08v.23h.23l33.9-.12,9.47-.06,2.49,0h.83L236.19,211l-7.6,9.33-12.5-17.58-15,27.41c0-6.45,0-13.44,0-20.84,0-3.75,0-7.59,0-11.52V186.07l46.2,0c.05,13.25.09,24.3.12,32.06,0,3.89,0,7,.06,9.08,0,1,0,1.84,0,2.41,0,.26,0,.46,0,.62s0,.21,0,.22a1.39,1.39,0,0,0,0-.2c0-.15,0-.35,0-.59q0-.84,0-2.37c0-2.11,0-5.15.06-9,0-7.84.07-19,.12-32.42v-.23Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 265.06,
    y: 181.39,
    width: 55.26,
    height: 53.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.46,197.42a4,4,0,1,1-4-4A4,4,0,0,1,302.46,197.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.05,185.58l-46.69,0c.06,0-.5.51-.26.28h0v23.51c0,7.49,0,14.57,0,21.08v.23h.23l33.91-.12,9.47-.06,2.48,0h.83L304.73,211l-7.59,9.33-12.51-17.58-15,27.41c0-6.45,0-13.44,0-20.84q0-5.62,0-11.52V186.07l46.21,0c0,13.25.08,24.3.11,32.06,0,3.89.05,7,.06,9.08,0,1,0,1.84,0,2.41,0,.26,0,.46,0,.62s0,.21,0,.22,0-.06,0-.2,0-.35,0-.59c0-.56,0-1.35,0-2.37,0-2.11,0-5.15.06-9,0-7.84.07-19,.12-32.42v-.23Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 196.52,
    y: 244.77,
    width: 55.26,
    height: 53.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.92,260.8a4,4,0,1,1-4-4A4,4,0,0,1,233.92,260.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.51,249l-46.69,0-.27.27h0v6c0,2,0,4,0,6v11.52c0,7.48,0,14.56,0,21.08V294h.23l33.9-.11,9.47-.06,2.49,0h.83l-11.32-19.41-7.6,9.34-12.5-17.58-15,27.4c0-6.44,0-13.44,0-20.83,0-3.75,0-7.6,0-11.52V249.45l46.2,0c.05,13.25.09,24.29.12,32.06,0,3.89,0,7,.06,9.08,0,1,0,1.83,0,2.4,0,.26,0,.47,0,.63s0,.21,0,.22a1.57,1.57,0,0,0,0-.2c0-.15,0-.35,0-.6,0-.56,0-1.34,0-2.36,0-2.11,0-5.16.06-9,0-7.84.07-19,.12-32.42V249Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 265.03,
    y: 244.77,
    width: 55.26,
    height: 53.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.43,260.8a4,4,0,1,1-4-4A4,4,0,0,1,302.43,260.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316,249l-46.69,0-.27.27h0v12c0,3.92,0,7.77,0,11.52,0,7.48,0,14.56,0,21.08V294h.23l33.9-.11,9.47-.06,2.48,0H316L304.7,274.39l-7.6,9.34-12.5-17.58-15,27.4c0-6.44,0-13.44,0-20.83,0-3.75,0-7.6,0-11.52V249.45l46.2,0c0,13.25.09,24.29.12,32.06,0,3.89,0,7,.06,9.08,0,1,0,1.83,0,2.4,0,.26,0,.47,0,.63a.82.82,0,0,0,0,.22,1.57,1.57,0,0,0,0-.2c0-.15,0-.35,0-.6,0-.56,0-1.34,0-2.36,0-2.11,0-5.16.06-9,0-7.84.07-19,.11-32.42V249Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M320.93,149.12a4,4,0,1,1,3.86-4,4.09,4.09,0,0,1-.63,2.21l.62,1.47a.2.2,0,0,1,0,.21.18.18,0,0,1-.2,0l-1.38-.64A3.71,3.71,0,0,1,320.93,149.12Zm0-7.69a3.66,3.66,0,0,0,0,7.32A3.37,3.37,0,0,0,323,148a.17.17,0,0,1,.18,0l1.06.49-.47-1.14a.19.19,0,0,1,0-.18,3.72,3.72,0,0,0,.63-2.08A3.59,3.59,0,0,0,320.93,141.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.79,149.26a.13.13,0,0,1-.1,0l-2.82-2-2.81,2a.19.19,0,0,1-.19,0,.2.2,0,0,1-.09-.16v-7.47a.18.18,0,0,1,.18-.18h5.83a.18.18,0,0,1,.18.18v7.47a.19.19,0,0,1-.1.16Zm-2.92-2.44a.2.2,0,0,1,.11,0l2.63,1.88v-6.94h-5.48v6.94l2.64-1.88A.19.19,0,0,1,331.87,146.82Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.15,149.76l.24,0,.69,0,2.52-.07-.09.09q0-.84,0-1.83c0-.34,0-.65,0-1.06a1,1,0,0,1,.87-.79c.41,0,.76,0,1.21,0a1,1,0,0,1,.85,1q0,1.28,0,2.67l-.14-.15,3.18,0-.15.15c0-1.28,0-2.6,0-4,0-.34,0-.68,0-1a1,1,0,0,0-.44-.73l-1.39-1.38-1.34-1.32-.65-.64c-.23-.22-.39-.44-.64-.49a.85.85,0,0,0-.71.14c-.19.15-.4.39-.59.57L184.38,142c-.72.74-1.48,1.43-2,2.06a2.15,2.15,0,0,0-.16,1.18v1.12c0,.67,0,1.28,0,1.8s0,.83,0,1.16,0,.41,0,.42a1.65,1.65,0,0,1,0-.38c0-.32,0-.69,0-1.13s0-1.14-.05-1.83c0-.36,0-.74,0-1.14a2.36,2.36,0,0,1,.17-1.31c.59-.73,1.29-1.36,2-2.14l1.13-1.16c.21-.2.37-.4.62-.61a1.14,1.14,0,0,1,.95-.19,1.75,1.75,0,0,1,.78.56l.65.64,1.35,1.32c.46.44.92.9,1.39,1.36a1.29,1.29,0,0,1,.53.95c0,.33,0,.67,0,1,0,1.36,0,2.69,0,4v.15h-3.48v-.15c0-.92,0-1.82,0-2.67a.76.76,0,0,0-.62-.75c-.36,0-.8,0-1.15,0a.77.77,0,0,0-.67.6c0,.31,0,.69,0,1v1.92h-.09l-2.57,0h-.67C182.21,149.77,182.14,149.77,182.15,149.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.63,
    y: 138.21,
    width: 116.21,
    height: 13.34,
    rx: 5.12,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42,144.68V147h-1.17v-2.13c0-.66-.3-1-.82-1s-1,.35-1,1.09v2h-1.17v-5.57h1.17v2a1.79,1.79,0,0,1,1.28-.48A1.59,1.59,0,0,1,211.42,144.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,146.79a1.61,1.61,0,0,1-1,.26,1.33,1.33,0,0,1-1.51-1.45v-1.66H212V143h.62v-1h1.17v1h1v.9h-1v1.65a.47.47,0,0,0,.5.53.78.78,0,0,0,.48-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,146.79a1.62,1.62,0,0,1-1,.26,1.33,1.33,0,0,1-1.5-1.45v-1.66h-.63V143h.63v-1H217v1h1v.9h-1v1.65a.47.47,0,0,0,.5.53.75.75,0,0,0,.47-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,145a2,2,0,0,1-2,2.08,1.57,1.57,0,0,1-1.22-.49v1.89h-1.17V143H220v.47a1.55,1.55,0,0,1,1.27-.53A2,2,0,0,1,223.32,145Zm-1.19,0a1,1,0,1,0-1,1.12A1,1,0,0,0,222.13,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.81,143.62a.73.73,0,0,1,1.46,0,.73.73,0,1,1-1.46,0Zm0,2.69a.73.73,0,0,1,1.46,0,.73.73,0,1,1-1.46,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.15,140.67h1l-2.48,7.07h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,140.67h1l-2.47,7.07h-1.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.92,385.23a22.53,22.53,0,0,0-36.9,8.86l2.67,10.33c1-3.52,3.19-6.92,6.55-8.37s7.55-.65,11.13.65,7.09,3.05,10.89,3.28,8.1-1.57,9.23-5.2C186.56,391.36,184.5,387.72,181.92,385.23Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.92,385.23a22.53,22.53,0,0,0-36.9,8.86l2.67,10.33c1-3.52,3.19-6.92,6.55-8.37s7.55-.65,11.13.65,7.09,3.05,10.89,3.28,8.1-1.57,9.23-5.2C186.56,391.36,184.5,387.72,181.92,385.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M117.57,419.69c-5.57-5.3-5.3-14.52-2.51-21.69s8.85-12.68,15.63-16.31a49.54,49.54,0,0,1,43.16-1.4A20.48,20.48,0,0,0,157.29,390c-3.06,5.07-3.74,11.23-6.26,16.59a26.14,26.14,0,0,1-33.46,13.08",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.89,387.86c-6.17-7.29-7-19-6.09-28.5s3.12-19.08,1.62-28.51c-.89-5.59-3.06-10.92-3.79-16.54s.3-11.95,4.65-15.58c5-4.16,12.87-3.18,18.07.73s8.21,10.05,10.41,16.17c4.84,13.45,6.61,28.36,2.64,42.09s-13.3,26-27,30.14",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93,447.66a4.53,4.53,0,0,1,0-.84c0-.55,0-1.36,0-2.41.08-2.09.28-5.11.75-8.82a116.62,116.62,0,0,1,2.37-12.93,59.85,59.85,0,0,1,5.9-15,62.55,62.55,0,0,1,9.64-12.88,61.07,61.07,0,0,1,10.11-8.41c1.54-1.06,3-1.87,4.31-2.62s2.47-1.26,3.41-1.72l2.22-.93a4.13,4.13,0,0,1,.79-.29,7,7,0,0,1-.75.38c-.53.26-1.26.59-2.17,1s-2.06,1.07-3.36,1.79-2.73,1.59-4.25,2.67a63.43,63.43,0,0,0-19.5,21.24c-5.68,9.93-7.24,20.38-8.36,27.69-.52,3.7-.77,6.71-.91,8.79-.06,1-.11,1.81-.14,2.4A5.62,5.62,0,0,1,111.93,447.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67,359.11C47.25,366,47.28,372.27,49.19,378.2s8.92,10,14.73,7.81c3.29-1.25,5.67-4.1,7.7-7s3.94-6,6.79-8a9.93,9.93,0,0,1,6.92-1.9Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.33,369.13l2.93,1.1A6.39,6.39,0,0,0,85.33,369.13Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.67,359.11C47.25,366,47.28,372.27,49.19,378.2s8.92,10,14.73,7.81c3.29-1.25,5.67-4.1,7.7-7s3.94-6,6.79-8a9.93,9.93,0,0,1,6.92-1.9Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.65,372l-10.59-4,4.34.58a6.89,6.89,0,0,1,3.15,1.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.12,366.67c3-4.13,10.36-5.33,15-3.27s8.08,6.15,11.13,10.22,6,8.39,10.26,11.22,10.15,3.87,14.36,1a12.34,12.34,0,0,0,4.88-8.45,27.91,27.91,0,0,0-.67-10c-1-4.79-2.65-9.79-6.49-12.84-4.27-3.39-10.2-3.55-15.65-3.37-6.26.2-12.61.67-18.48,2.84s-11.87,6.85-14.36,12.6",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.43,438.51a.79.79,0,0,1,0-.25l0-.74c0-.68,0-1.63-.09-2.83-.08-2.51-.18-6.06-.3-10.43s-.32-9.64-.64-15.45-.76-12.2-1.64-18.85a61.07,61.07,0,0,0-1.89-9.58A50.15,50.15,0,0,0,94.3,372a48.59,48.59,0,0,0-4.42-6.94,45.1,45.1,0,0,0-4.82-5.29A35.57,35.57,0,0,0,76.51,354c-.56-.26-1.05-.51-1.48-.68l-1.12-.44-.68-.27-.23-.11.24.06.71.23,1.13.39c.45.16.94.4,1.51.64a34.33,34.33,0,0,1,8.71,5.74,44.83,44.83,0,0,1,4.92,5.3,47.87,47.87,0,0,1,4.49,7,49.31,49.31,0,0,1,3.57,8.45,60.16,60.16,0,0,1,1.92,9.65c.88,6.68,1.3,13.07,1.6,18.89s.43,11.07.53,15.47.12,8,.13,10.44c0,1.2,0,2.14,0,2.83,0,.3,0,.54,0,.74A.67.67,0,0,1,102.43,438.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,443.68a32.74,32.74,0,0,1-1.25-4.91,51.7,51.7,0,0,1-.52-13.78,92,92,0,0,1,4.35-20c2.35-7.35,5.53-15.21,8.25-23.66a109.27,109.27,0,0,0,3.28-12.52,110.19,110.19,0,0,0,1.62-11.94,173.75,173.75,0,0,0,.36-20.42c-.19-5.82-.5-10.53-.7-13.78-.09-1.6-.16-2.85-.22-3.74,0-.41,0-.73,0-1a1.37,1.37,0,0,1,0-.33,1.23,1.23,0,0,1,0,.33c0,.24.06.57.1,1,.07.89.18,2.14.31,3.74.26,3.25.62,7.95.86,13.77a166.42,166.42,0,0,1-.25,20.48,111.7,111.7,0,0,1-1.6,12,107.63,107.63,0,0,1-3.28,12.58c-2.73,8.47-5.93,16.32-8.29,23.64A93.11,93.11,0,0,0,105.13,425a53.33,53.33,0,0,0,.36,13.71c.28,1.6.54,2.84.76,3.67.1.39.17.71.23,1A1.27,1.27,0,0,1,106.54,443.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.87 448.84 81.23 448.84 80 438.51 134.87 438.51 134.87 448.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.98 447.66 93.69 478.63 122.84 478.63 129.11 447.66 86.98 447.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87,448.84c0,.14-11.8.22-26.34.18s-26.34-.19-26.34-.33,11.79-.22,26.34-.18S134.87,448.7,134.87,448.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,464.13a21.87,21.87,0,0,0-4.72-2.71,16.69,16.69,0,0,0-5.75-1.16,20.18,20.18,0,0,0-7.06,1.3c-2.45.83-4.73,1.79-6.95,2.32a16.49,16.49,0,0,1-6,.18,12.51,12.51,0,0,1-3.86-1.22,7.09,7.09,0,0,1-.93-.59c-.21-.16-.31-.24-.29-.26s.45.27,1.31.67a13.24,13.24,0,0,0,3.82,1,16.74,16.74,0,0,0,5.85-.28c2.15-.54,4.43-1.51,6.9-2.34a20,20,0,0,1,7.23-1.29,16.58,16.58,0,0,1,5.87,1.29,15.44,15.44,0,0,1,3.5,2,9.72,9.72,0,0,1,.83.72C125.58,464,125.67,464.11,125.66,464.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.25,466.19a23.32,23.32,0,0,0-4.53-2.67,15.36,15.36,0,0,0-5.54-1.14,20,20,0,0,0-6.84,1.23c-2.36.79-4.58,1.71-6.69,2.28a17.25,17.25,0,0,1-5.78.64,9.61,9.61,0,0,1-3.78-1,6.54,6.54,0,0,1-.91-.57c-.19-.15-.29-.23-.28-.24s.45.25,1.27.63a10.31,10.31,0,0,0,3.72.83,17.49,17.49,0,0,0,5.63-.74c2.07-.58,4.27-1.51,6.66-2.31a19.8,19.8,0,0,1,7-1.21,15.19,15.19,0,0,1,5.67,1.28,14.78,14.78,0,0,1,3.35,2,7.11,7.11,0,0,1,.79.7C125.18,466.09,125.26,466.18,125.25,466.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19,462.07a25.67,25.67,0,0,0-4.85-2.86,17.88,17.88,0,0,0-5.89-1.41,19.11,19.11,0,0,0-7.29,1.28,63.77,63.77,0,0,1-7.19,2.35,18.43,18.43,0,0,1-6.21,0,13.8,13.8,0,0,1-4-1.26,6.35,6.35,0,0,1-1-.6c-.21-.15-.31-.24-.3-.26s.47.28,1.35.68a15.59,15.59,0,0,0,4,1.09,18.9,18.9,0,0,0,6.06-.12A75,75,0,0,0,108,458.6a19,19,0,0,1,7.48-1.27,17.48,17.48,0,0,1,6,1.55,17.19,17.19,0,0,1,3.57,2.16,7.83,7.83,0,0,1,.86.74C126.11,462,126.2,462.06,126.19,462.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,448.88c0,.14-12.07.26-26.95.26s-26.95-.12-26.95-.26,12.07-.25,27-.25S135.34,448.74,135.34,448.88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.57,216.23l-2.31-43.64a41.29,41.29,0,0,0-1.48-10.52,13.85,13.85,0,0,0-6.35-8.22c-3.16-1.64-7.42-1.35-9.85,1.24l1.72,2.36q-2.12,40.07-1.8,80.22c0,2,.08,4.15,1.25,5.77,2,2.73,6,2.7,9.32,2.39,2.87-.26,6.13-.74,7.73-3.13a8.91,8.91,0,0,0,1.16-3.35C375.38,231.75,375,224,374.57,216.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.72,160a8.1,8.1,0,0,0-4.56-4.5c-2.09-.68-4.72.13-5.63,2.13l4.93,5.56a5,5,0,0,0,2.05,1.91,2.82,2.82,0,0,0,2.72-.15,2.89,2.89,0,0,0,1.15-2.34A6,6,0,0,0,360.72,160Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,183.21c-.85-9.42-5.83-18.59-13.81-23.67S336.32,154,328.34,159a28,28,0,0,0-10.83,14c-2.1,5.64-1.19,10.31-1.14,16.32,0,3.12.42,11.49,3.11,13.06l42,7.53C366.82,202.18,369.86,192.63,369,183.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.54,176c-1-5.6-6.42-11-10.68-14.79-4.86-4.28-5.55-4.09-12-4.25-6.83-.18-14.29-.15-19.62,4.13-3,2.37-4.87,5.79-6.41,9.24-3.56,8-3,17.13-1.93,25.81s2.93,16.88,10,22l29.87-4.62c6.59-2.45,8.79-10,10.65-16.75S368.7,182.91,367.54,176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,181.55c.42-8.21,9.16-16.51,17.35-15.75l26.59,4.73,0,4.42.3,55.16A229.59,229.59,0,0,1,331.47,235l-.23-11.06s-10.51-1.62-12.85-15.27C317.23,201.84,317.43,190.68,317.9,181.55Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.88,192.43a1.76,1.76,0,0,0,1.71,1.75,1.68,1.68,0,0,0,1.79-1.61,1.75,1.75,0,0,0-1.71-1.75A1.68,1.68,0,0,0,322.88,192.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.86,187.33c.22.23,1.54-.77,3.43-.79s3.28.91,3.49.68-.13-.52-.74-.95a4.82,4.82,0,0,0-2.79-.82,4.65,4.65,0,0,0-2.73.91C321,186.82,320.75,187.23,320.86,187.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.68,192.43a1.76,1.76,0,0,0,1.72,1.75,1.68,1.68,0,0,0,1.79-1.61,1.76,1.76,0,0,0-1.71-1.75A1.69,1.69,0,0,0,339.68,192.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43,187.46c.22.23,1.54-.77,3.43-.79s3.28.91,3.48.68-.12-.52-.73-.95a4.83,4.83,0,0,0-2.8-.82,4.62,4.62,0,0,0-2.72.91C339.51,186.94,339.32,187.36,339.43,187.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,201.55a12.06,12.06,0,0,0-3.07-.52c-.48,0-.94-.13-1-.46a2.39,2.39,0,0,1,.3-1.43l1.38-3.69c1.92-5.25,3.3-9.57,3.09-9.65s-1.94,4.12-3.86,9.38l-1.32,3.71a2.84,2.84,0,0,0-.23,1.89,1.24,1.24,0,0,0,.81.7,3.2,3.2,0,0,0,.82.1A12.15,12.15,0,0,0,332.74,201.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.24,223.94A36.26,36.26,0,0,0,350,218.8s-4.51,9.64-18.69,8.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6,206.09a3.4,3.4,0,0,1,3-1.3,3.1,3.1,0,0,1,2.16,1.12,2,2,0,0,1,.18,2.25,2.28,2.28,0,0,1-2.47.66,7.26,7.26,0,0,1-2.43-1.41,2.06,2.06,0,0,1-.55-.55.63.63,0,0,1,0-.71",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.32,202.79c-.31,0-.29,2-2,3.51s-3.92,1.28-3.93,1.56c0,.13.49.39,1.41.41a5.12,5.12,0,0,0,3.29-1.19,4.44,4.44,0,0,0,1.56-2.94C338.69,203.28,338.46,202.77,338.32,202.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.94,182.13c.19.51,2.08.25,4.29.49s4,.82,4.31.36c.13-.22-.19-.7-.92-1.19a7.12,7.12,0,0,0-3.2-1.08,7.3,7.3,0,0,0-3.35.43C339.26,181.48,338.86,181.89,338.94,182.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,180.86c.34.42,1.63,0,3.2-.08s2.89.25,3.19-.2c.13-.22-.08-.65-.67-1.05a4.49,4.49,0,0,0-2.6-.67,4.4,4.4,0,0,0-2.54.9C320.87,180.2,320.69,180.65,320.84,180.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.09,162c-5,3.41-8.52,9-10.22,15.19l.84,5.07c1.17-2.45,1.32-5.08,3.74-7.59a17.35,17.35,0,0,1,7.81-4.09c9.12-2.32,12.19-5.63,16.22-11.59C339.57,157.5,332.13,158.58,327.09,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.45,175.36a25.07,25.07,0,0,0-20.23-17.69l-.74,1.31-6.93,8.1a4.78,4.78,0,0,0-1.3,2.27,3.49,3.49,0,0,0,1.47,3.06c2.2,1.8,5.27,1.91,8.11,2s5.94.31,8,2.25c2.57,2.42,2.51,6.53,1.65,10a42.37,42.37,0,0,0-.85,12.46c.32,3.15,4.48-4.5,7.22-2.91.76.44-1.3,12.8-.5,12.42s.71-4.82,1-5.65a98.68,98.68,0,0,0,3.56-13.61A32.69,32.69,0,0,0,366.45,175.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.68,199.13a4.08,4.08,0,0,1,6.05-3.34c1.4.84,2.45,2.52,2.25,5.68-.53,8.42-8.88,6.15-8.87,5.91S358.43,202.62,358.68,199.13Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,204.34s.14.12.38.25a1.47,1.47,0,0,0,1.09.09c.91-.27,1.76-1.63,1.9-3.14a4.91,4.91,0,0,0-.27-2.13,1.7,1.7,0,0,0-1-1.2.74.74,0,0,0-.89.34c-.13.23-.09.4-.13.41s-.18-.15-.08-.49a.88.88,0,0,1,.36-.51,1.14,1.14,0,0,1,.83-.16,2.06,2.06,0,0,1,1.44,1.41,5,5,0,0,1,.36,2.38c-.17,1.69-1.15,3.22-2.39,3.49a1.53,1.53,0,0,1-1.32-.31C360.87,204.55,360.84,204.36,360.87,204.34Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,164.3a27.6,27.6,0,0,1,3,4.25,34.66,34.66,0,0,1,2.47,5.09,35.77,35.77,0,0,1,1.88,6.66,32.68,32.68,0,0,1-.13,12.52,10.82,10.82,0,0,1-.27,1.12c-.1.34-.19.67-.27,1a11.8,11.8,0,0,1-.52,1.56l-.36,1-.14.33a1.61,1.61,0,0,1,.09-.35c.08-.25.19-.57.32-1a16,16,0,0,0,.47-1.56l.25-1a10.93,10.93,0,0,0,.25-1.12,33.44,33.44,0,0,0,.06-12.43,37.54,37.54,0,0,0-1.85-6.63,38.15,38.15,0,0,0-2.4-5.08l-.57-1-.56-.85-.48-.75c-.15-.23-.3-.42-.43-.6l-.61-.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.63,166.87a2.12,2.12,0,0,1-.05.25,2,2,0,0,1-.34.68,4.58,4.58,0,0,1-2.3,1.49c-1.12.37-2.46.7-4,1a35.22,35.22,0,0,1-5,.72,24.17,24.17,0,0,1-5-.14,19.15,19.15,0,0,1-4-1,15.21,15.21,0,0,1-2.49-1.18,5.83,5.83,0,0,1-.63-.41c-.14-.09-.22-.15-.21-.16s.31.18.89.48a16.81,16.81,0,0,0,2.5,1.1,20.11,20.11,0,0,0,3.94.92,25.17,25.17,0,0,0,5,.13,44.61,44.61,0,0,0,8.87-1.67,4.69,4.69,0,0,0,2.28-1.38A3.64,3.64,0,0,0,361.63,166.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,164s0,.06-.14.17-.24.27-.44.45a10.45,10.45,0,0,1-1.87,1.36,15,15,0,0,1-7.35,1.85,30.63,30.63,0,0,1-7.55-1c-.94-.24-1.7-.45-2.23-.6a5.87,5.87,0,0,1-.8-.26,4.91,4.91,0,0,1,.83.16l2.24.52a33.61,33.61,0,0,0,7.5,1,15.67,15.67,0,0,0,7.27-1.75A15.44,15.44,0,0,0,360.11,164Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,163a2.91,2.91,0,0,1-.59.2c-.39.12-1,.27-1.67.42a27,27,0,0,1-11.28-.07c-.71-.15-1.28-.31-1.67-.43a3.24,3.24,0,0,1-.59-.21,2.62,2.62,0,0,1,.62.11c.39.1,1,.22,1.67.35a30.38,30.38,0,0,0,5.61.55,32.07,32.07,0,0,0,5.6-.48c.72-.13,1.29-.24,1.68-.33A2.62,2.62,0,0,1,358.38,163Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,155.85a3.53,3.53,0,0,1-.2.6c-.15.38-.39.92-.71,1.57a23.52,23.52,0,0,1-7.41,8.56c-.6.42-1.1.73-1.45.93a3.71,3.71,0,0,1-.57.29,2.75,2.75,0,0,1,.51-.37c.34-.23.83-.56,1.41-1a26.23,26.23,0,0,0,4.13-3.85,26,26,0,0,0,3.21-4.64c.35-.64.61-1.17.79-1.53A2.46,2.46,0,0,1,347.14,155.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,173.94s0-.09.14-.22.25-.34.46-.59a27,27,0,0,1,1.84-2.06,22.13,22.13,0,0,1,3.13-2.64,19.7,19.7,0,0,1,2.08-1.24,18.68,18.68,0,0,1,2.41-1,22.55,22.55,0,0,1,9-1,20,20,0,0,1,2.72.44c.32.07.56.15.72.19a.9.9,0,0,1,.25.09s-.35-.06-1-.18a25.49,25.49,0,0,0-2.72-.36,23.37,23.37,0,0,0-8.91,1,19.45,19.45,0,0,0-7.57,4.75c-.83.81-1.46,1.5-1.89,2l-.5.56A1.83,1.83,0,0,1,317.21,173.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,164.88a5.55,5.55,0,0,1,.64-.42A8.53,8.53,0,0,1,325,164c.32-.16.67-.36,1.08-.53s.85-.38,1.35-.55a16.5,16.5,0,0,1,1.59-.52,21.76,21.76,0,0,1,7.59-.75c.58.06,1.14.11,1.66.21s1,.18,1.43.28a11.27,11.27,0,0,1,1.16.31,8.76,8.76,0,0,1,.86.28,5.08,5.08,0,0,1,.71.29,3.88,3.88,0,0,1-.75-.19,6.74,6.74,0,0,0-.86-.24c-.34-.09-.73-.2-1.16-.28s-.91-.18-1.42-.24-1.07-.13-1.65-.18a25.53,25.53,0,0,0-3.79,0,24.4,24.4,0,0,0-3.72.69c-.56.16-1.1.3-1.58.49s-.94.35-1.35.52-.76.34-1.08.49-.59.28-.81.4A3.21,3.21,0,0,1,323.53,164.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.35,206.46c.16-.08.41,0,.69.31a3.18,3.18,0,0,1,.76,1.58,3.85,3.85,0,0,1,0,1.32,3.57,3.57,0,0,1-.63,1.51,3.74,3.74,0,0,1-1.45,1.19,3.21,3.21,0,0,1-2.18.2,3.31,3.31,0,0,1-1.78-1.21,3.8,3.8,0,0,1-.73-1.7,3.73,3.73,0,0,1,.71-2.79,3.33,3.33,0,0,1,1.35-1.11c.38-.15.64-.13.75,0s-.23,1-.5,1.95a2.52,2.52,0,0,0,0,1.44,1.46,1.46,0,0,0,.86.93,1,1,0,0,0,.53,0,1.81,1.81,0,0,0,.6-.37,2.26,2.26,0,0,0,.63-1.26C365.17,207.45,365,206.62,365.35,206.46Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.21 272.89 317.53 301.14 314.54 320.1 383.95 320.1 379.42 231.59 362.11 230.12 319.83 237.25 311.21 272.89",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.87,236.74s-18.08-1.66-26.69,10.65c-5.27,7.52-12.67,24.81-12.67,24.81l24.07,4.15Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M353.07,263.48c5.08,6.27,7.47,14.23,10.79,21.59,4.28,9.48,10.21,18.11,16.1,26.68.44.64,1,1.36,1.82,1.27s1.21-1,1.42-1.79a25.13,25.13,0,0,0-1-14.74,56.1,56.1,0,0,0-7.2-13.12A152.18,152.18,0,0,0,360,265.08a8.65,8.65,0,0,0-3.37-2.5,3,3,0,0,0-3.67,1.27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M317.29,296.23q1.75-6.93,3.52-13.86a10.07,10.07,0,0,1,.95-2.68,10.43,10.43,0,0,1,2.45-2.6,11.11,11.11,0,0,1,3.73-2.35,21.58,21.58,0,0,0,3.5-.87c1.48-.74,2.27-2.35,2.88-3.89.46-1.18.85-2.58.18-3.65a3.8,3.8,0,0,0-3.2-1.34,14.69,14.69,0,0,0-13.39,8.23c-1.8,3.86-1.8,8.29-1.77,12.55l.1,11.39"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M339.49,296.77c0-.06-.94.1-2.46.22a29.84,29.84,0,0,1-5.93-.15,29.22,29.22,0,0,1-5.76-1.38c-1.44-.5-2.3-.9-2.33-.84s.19.16.57.36a15.51,15.51,0,0,0,1.65.76,24.4,24.4,0,0,0,5.82,1.52,24.06,24.06,0,0,0,6,0,13.59,13.59,0,0,0,1.79-.31C339.27,296.87,339.5,296.8,339.49,296.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.78,298c0-.12-9.86,2.68-21.94,6.25S326,310.81,326,310.92s9.86-2.68,21.94-6.25S369.81,298.13,369.78,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324,295.1a8.41,8.41,0,0,0,7,5.39,8.7,8.7,0,0,0,8.14-3.79A30.41,30.41,0,0,1,324,295.1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.67,310.06l.25.1c6.2,1.11,12,0,17.94-2.11s11.48-5.16,17-8.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,309.37a4.07,4.07,0,0,1,0,1.8,10.55,10.55,0,0,1-4.68,7.09,4.08,4.08,0,0,1-1.64.73,13.35,13.35,0,0,1,1.43-1,12.6,12.6,0,0,0,2.86-3,12.4,12.4,0,0,0,1.67-3.83A12.94,12.94,0,0,1,365.57,309.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.16,313.65a3.48,3.48,0,0,1-.77,1.42,9.73,9.73,0,0,1-6.65,3.76,3.45,3.45,0,0,1-1.61-.08,16,16,0,0,0,5.06-1.57A16.16,16.16,0,0,0,369.16,313.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.28,393.92c-1.28-5.24-10.54-39.13-12.32-44.23l-8.34-23.88-.56-7.89-70.73,2.18s-10.07,12.4-13.8,26.46c-3.21,12.05-4.83,30.34,2.76,77.9,5,26.39,10.78,54.47,10.78,54.47h42.37l-5.67-97.15,15.72,54.4,14.33,42.73,45.32-.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,331.62a3.3,3.3,0,0,1-.12.37c-.09.26-.22.61-.38,1.05s-.39,1-.65,1.72-.55,1.45-.82,2.35a91.78,91.78,0,0,0-3.69,15.45,133.27,133.27,0,0,0-1.32,23.52c.21,8.87,1.09,18.61,2.2,28.81C307,425.28,311,443.46,314,456.57c1.5,6.54,2.72,11.83,3.56,15.53.42,1.81.74,3.22,1,4.22l.24,1.1a1.83,1.83,0,0,1,.06.38,1.91,1.91,0,0,1-.12-.37l-.28-1.09c-.25-1-.61-2.4-1.06-4.2-.91-3.65-2.2-8.93-3.73-15.48-3-13.1-7.08-31.28-9.34-51.72-1.11-10.2-2-19.95-2.17-28.85a131.33,131.33,0,0,1,1.43-23.59,87.49,87.49,0,0,1,3.87-15.45c.28-.9.59-1.68.87-2.35L309,333l.43-1A1.33,1.33,0,0,1,309.56,331.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.07,475.26c.14,0,.38.49.55,1.16s.17,1.24,0,1.27-.38-.48-.54-1.15S321.93,475.3,322.07,475.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,465.62a12.05,12.05,0,0,1,1.14,4.83,12.16,12.16,0,0,1-1.14-4.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52,456a6.17,6.17,0,0,1,.81,2.35,6.07,6.07,0,0,1,.3,2.48,6.18,6.18,0,0,1-.81-2.36A6,6,0,0,1,317.52,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.37,446.29a6.13,6.13,0,0,1,.78,2.36,6,6,0,0,1,.28,2.48,6.25,6.25,0,0,1-.79-2.37A6.09,6.09,0,0,1,315.37,446.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,436.58a6.11,6.11,0,0,1,.75,2.38,5.9,5.9,0,0,1,.23,2.48,12.18,12.18,0,0,1-1-4.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,426.84a5.94,5.94,0,0,1,.7,2.39,6.32,6.32,0,0,1,.19,2.49,12,12,0,0,1-.89-4.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,417.06a11.82,11.82,0,0,1,.76,4.9,11.82,11.82,0,0,1-.76-4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,407.25a11.8,11.8,0,0,1,.62,4.91,6.06,6.06,0,0,1-.57-2.42A6.17,6.17,0,0,1,308.65,407.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.61,397.4a11.81,11.81,0,0,1,.5,4.92,6.12,6.12,0,0,1-.51-2.43A6.34,6.34,0,0,1,307.61,397.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.76,387.53a11.68,11.68,0,0,1,.39,4.94,6.32,6.32,0,0,1-.45-2.45A6,6,0,0,1,306.76,387.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.23,377.64a11.69,11.69,0,0,1,.21,4.95,6.35,6.35,0,0,1-.36-2.47A6.14,6.14,0,0,1,306.23,377.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.2,367.73a6,6,0,0,1,.23,2.48,5.84,5.84,0,0,1-.29,2.47,6.22,6.22,0,0,1-.23-2.47A6.32,6.32,0,0,1,306.2,367.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,357.85a6,6,0,0,1,.06,2.49,6.25,6.25,0,0,1-.47,2.44,5.88,5.88,0,0,1-.05-2.49A6.08,6.08,0,0,1,306.84,357.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.34,348.06a6.15,6.15,0,0,1-.18,2.48,6,6,0,0,1-.69,2.39,6.15,6.15,0,0,1,.18-2.48A6.07,6.07,0,0,1,308.34,348.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.83,338.47a11.83,11.83,0,0,1-1.38,4.76,6.13,6.13,0,0,1,.44-2.45A6,6,0,0,1,310.83,338.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,331.52c.13.05,0,.61-.23,1.25s-.57,1.11-.71,1.06,0-.61.23-1.25S313.28,331.46,313.41,331.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,387.05c-.13.07-.84-.8-1.59-1.95a6.28,6.28,0,0,1-1.14-2.24c.11-.09.82.79,1.58,1.95A6.33,6.33,0,0,1,354.37,387.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.66,396.07a6.47,6.47,0,0,1-1.23-2.19,6.23,6.23,0,0,1-.74-2.4,6.3,6.3,0,0,1,1.22,2.19A6.08,6.08,0,0,1,358.66,396.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.89,405.53a6,6,0,0,1-1-2.3,6.1,6.1,0,0,1-.51-2.46,6.23,6.23,0,0,1,1,2.3A6.15,6.15,0,0,1,361.89,405.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.71,415.13a12.17,12.17,0,0,1-1.4-4.8,6.06,6.06,0,0,1,.95,2.33A6.55,6.55,0,0,1,364.71,415.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.49,424.74a6.34,6.34,0,0,1-.95-2.33,6.24,6.24,0,0,1-.44-2.48,6.23,6.23,0,0,1,.94,2.33A6.15,6.15,0,0,1,367.49,424.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,434.34a6.06,6.06,0,0,1-.95-2.33,6.53,6.53,0,0,1-.45-2.47,6.06,6.06,0,0,1,.95,2.33A6.53,6.53,0,0,1,370.28,434.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.06,444a6.34,6.34,0,0,1-.95-2.33,6.24,6.24,0,0,1-.44-2.48,6.34,6.34,0,0,1,.95,2.33A6.24,6.24,0,0,1,373.06,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.85,453.55a6.06,6.06,0,0,1-1-2.33,6.53,6.53,0,0,1-.45-2.47,6.06,6.06,0,0,1,.95,2.33A6.53,6.53,0,0,1,375.85,453.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.63,463.15a12.25,12.25,0,0,1-1.39-4.8,11.94,11.94,0,0,1,1.39,4.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.42,472.76a6.06,6.06,0,0,1-.95-2.33A6.55,6.55,0,0,1,380,468a6.06,6.06,0,0,1,1,2.32A6.36,6.36,0,0,1,381.42,472.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,479.38c-.14,0-.37-.34-.52-.84s-.15-.94,0-1,.37.33.51.84S383.47,479.34,383.34,479.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.9,319.25a2.45,2.45,0,0,1,.07.58c0,.44,0,1,.09,1.67.07,1.45.14,3.54.16,6.14.07,5.18-.06,12.35-.61,20.24C356,357,354.86,365.1,354,370.19l0,.13h-.13l-4.57.1H348.1a1.57,1.57,0,0,1-.42,0,1.54,1.54,0,0,1,.42-.06l1.21-.09,4.56-.25-.16.14c.71-5.1,1.74-13.17,2.38-22.29.55-7.88.74-15,.76-20.21,0-2.54,0-4.62,0-6.14v-1.67A2.39,2.39,0,0,1,356.9,319.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.53,322.33s-.14.18-.34.49a2.78,2.78,0,0,0-.43,1.49,2.69,2.69,0,0,0,.86,2,2.5,2.5,0,0,0,3.93-2,2.79,2.79,0,0,0-2.57-2.44c-.37,0-.59,0-.6,0s.19-.14.6-.19a2.7,2.7,0,0,1,1.66.45,3,3,0,0,1,1.39,2.16,2.95,2.95,0,0,1-4.72,2.38,3,3,0,0,1-.92-2.4,2.75,2.75,0,0,1,.63-1.6C348.3,322.39,348.52,322.31,348.53,322.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.38,321.9a4.19,4.19,0,0,1-.12,1.16,18,18,0,0,1-.86,3.07A20.23,20.23,0,0,1,317.91,339a16.78,16.78,0,0,1-3.17.29,4.27,4.27,0,0,1-1.16-.08c0-.1,1.67,0,4.26-.57A20.92,20.92,0,0,0,333.06,326C334.06,323.54,334.28,321.88,334.38,321.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,340.78a4.21,4.21,0,0,1-1.06-.42,20.48,20.48,0,0,1-2.64-1.63,41,41,0,0,1-7.21-7.18,73.89,73.89,0,0,1-6.16-8.11,26,26,0,0,1-1.47-2.72,4.34,4.34,0,0,1-.4-1.06c.08,0,.74,1.43,2.18,3.58a96,96,0,0,0,6.25,8,47.31,47.31,0,0,0,7,7.22C388.23,340,389.71,340.7,389.67,340.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.42,451.59a4.59,4.59,0,0,1-1,.06,26.44,26.44,0,0,1-2.72-.15,36,36,0,0,1-8.77-2,36.43,36.43,0,0,1-8-4.1,26,26,0,0,1-2.18-1.65c-.49-.42-.74-.66-.72-.69s1.17.81,3.1,2a41.83,41.83,0,0,0,16.62,6.06C346,451.45,347.42,451.5,347.42,451.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,444.84a16.91,16.91,0,0,1-1.5,2.81c-1,1.69-2.47,4-4.23,6.4s-3.48,4.53-4.78,6a16.17,16.17,0,0,1-2.2,2.28,21.74,21.74,0,0,1,1.92-2.52c1.22-1.53,2.89-3.65,4.64-6.07s3.26-4.65,4.34-6.29A21.82,21.82,0,0,1,404.67,444.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.1,251.72c-.3-3.68,3.91-8,5.11-11.5,2.42-7.05,2.17-10.11,1.36-24l-12.3-2.62c-.38,4.63.29,2.82-.15,7.83a31.91,31.91,0,0,1-4.39,14.28c-1.92,3.05-4.61,5.87-5,9.45-.53,5.17,4,9.63,4.31,14.82.4,7.21-7.4,13.16-6.45,20.31a5.06,5.06,0,0,0,2.36,3.95,7,7,0,0,0,3.38.51l7.58-.1a3.25,3.25,0,0,0,2.3-.62c.94-.92.44-2.47.25-3.78-.85-5.62,5.17-10.24,5.32-15.93C371.92,259.92,368.47,256.12,368.1,251.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.18,269.22s21.2,47.2,33.52,48.65c6.21.73,10-2.67,11.33-9.11s-3.11-48.65-3.11-48.65L380.59,266l1.62,8.18L369.44,261.5Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,231.59s11.93,1.14,16.37,10.92,10.6,20.8,10.6,20.8l-26.24,5.91s-3.67-19.74-3.95-26.71C375.89,234.88,375.1,231.37,379.42,231.59Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.39,292.17a2.43,2.43,0,0,0-.3-.33l-.9-.89-3.35-3.26c-2.83-2.75-6.72-6.56-11-10.8S376.79,268.82,374,266l-3.29-3.31-.9-.89c-.21-.2-.33-.31-.34-.29a1.5,1.5,0,0,0,.27.34l.85,1c.74.82,1.83,2,3.19,3.41,2.72,2.86,6.53,6.76,10.81,11s8.19,8,11.07,10.72c1.44,1.35,2.62,2.43,3.44,3.16l1,.83A1.83,1.83,0,0,0,400.39,292.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,232.56l8.29,3.23s4.56,0,5.15,1.51l1.18,2.94s2.79.71,3.38,2.27,5.44,12.15,5.44,12.15l4.56,6.84-9.26,7.72a21.54,21.54,0,0,0-3.83-3.83c-1.91-1.32-9.85-8-10-9.8s-4.44-12-4.49-13.08-.16-3.44.92-2.85,2.54,3.53,2.54,3.53l-1-4a6.74,6.74,0,0,1-2.76-4.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.86,256.51a8.22,8.22,0,0,0-.85-1.22l-2.44-3.17-.05-.06h-.08l-3.16,0h-.12l-.06.11a3.31,3.31,0,0,1-1.49,1.56,3.65,3.65,0,0,1-1.15.15,10.21,10.21,0,0,1-1.24,0l.16.3.56-1.13,2-4.06-.18.11,5.59-.05h-.07l3.09,1.44a8.2,8.2,0,0,0,1.17.48,7.15,7.15,0,0,0-1.09-.63l-3-1.57,0,0h0l-5.59,0h-.12l-.06.11-2,4-.56,1.13-.14.27.3,0a8.3,8.3,0,0,0,1.31,0l.64,0a1.92,1.92,0,0,0,.66-.15,3.66,3.66,0,0,0,1.68-1.78l-.17.11,3.16,0-.13-.06,2.55,3.09A9.32,9.32,0,0,0,358.86,256.51Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.06,243.84a8.4,8.4,0,0,0-1.37-.09l-3.71-.07h-.64l.57.31a11.37,11.37,0,0,1,2.42,1.62c.18.18.31.39.24.52a1.28,1.28,0,0,1-.54.47,7.13,7.13,0,0,1-1.6.64h.06a7.62,7.62,0,0,1-3.13-1,3.07,3.07,0,0,1-1.19-2.5,11.34,11.34,0,0,1,.11-2.81l-.18.16,6.46-.51,1.84-.18a2.27,2.27,0,0,0,.66-.11,3.17,3.17,0,0,0-.67,0l-1.84.07-6.47.35h-.16l0,.15a11.6,11.6,0,0,0-.15,2.91,5.69,5.69,0,0,0,.34,1.54,2.46,2.46,0,0,0,1.06,1.3,7.91,7.91,0,0,0,3.34,1.08h.06a7.54,7.54,0,0,0,1.68-.7,1.48,1.48,0,0,0,.69-.67.61.61,0,0,0,0-.56,1.72,1.72,0,0,0-.28-.36,11,11,0,0,0-2.55-1.64l-.07.3,3.71-.07A8.4,8.4,0,0,0,356.06,243.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.44,261.5l-.06-.13-.22-.35-.86-1.35L365,254.59v0c-.89-2-1.94-4.38-3.12-7.07q-.9-2-1.89-4.26c-.18-.38-.32-.72-.53-1.15a3.24,3.24,0,0,0-.92-1,8,8,0,0,0-2.43-1.11l.13.11-.77-1.93-.39-1a1.84,1.84,0,0,0-.86-.84,7.57,7.57,0,0,0-2.18-.63,19.11,19.11,0,0,0-2.29-.2l.07,0-8.3-3.24-.3-.12v.33c0,.77.06,1.54.12,2.38a6.43,6.43,0,0,0,.88,2.37,7.5,7.5,0,0,0,2,2.08l-.1-.13c.35,1.35.69,2.68,1,4l.39-.15a20.89,20.89,0,0,0-1.1-1.9,6.08,6.08,0,0,0-1.46-1.67.78.78,0,0,0-.68-.12.82.82,0,0,0-.44.51,4,4,0,0,0-.19,1.1q0,.53,0,1.05c0,.18,0,.34,0,.53a3.74,3.74,0,0,0,.13.53c.85,2.62,1.86,5,2.71,7.36.43,1.17.85,2.3,1.22,3.41a12,12,0,0,1,.44,1.63,3.53,3.53,0,0,0,.8,1.55,38.16,38.16,0,0,0,4.3,4.32c1.39,1.23,2.68,2.3,3.83,3.2.58.45,1.15.84,1.64,1.21a13.45,13.45,0,0,1,1.28,1.11c.73.71,1.26,1.3,1.61,1.7l.4.46.15.15a1.13,1.13,0,0,0-.12-.18c-.09-.13-.22-.28-.37-.48a20.88,20.88,0,0,0-1.56-1.76,15.26,15.26,0,0,0-1.28-1.15c-.5-.39-1-.77-1.61-1.23-1.14-.92-2.41-2-3.78-3.23a40.52,40.52,0,0,1-4.23-4.32,3.34,3.34,0,0,1-.72-1.38,12.28,12.28,0,0,0-.45-1.71c-.36-1.12-.77-2.26-1.2-3.43C344,248,343,245.58,342.19,243a2.18,2.18,0,0,1-.11-.46,4.07,4.07,0,0,1,0-.5c0-.34,0-.68,0-1,0-.62.17-1.58.68-1.16a5.64,5.64,0,0,1,1.33,1.55,17.94,17.94,0,0,1,1.07,1.86L346,245l-.48-1.85c-.33-1.29-.67-2.62-1-4l0-.07-.08-.06a7,7,0,0,1-1.82-1.94,5.94,5.94,0,0,1-.82-2.2c-.05-.77-.08-1.58-.11-2.34l-.29.2,8.3,3.23h.07a11.38,11.38,0,0,1,4.3.77,1.45,1.45,0,0,1,.68.63c.13.34.27.67.4,1l.77,1.92,0,.09.09,0a7.55,7.55,0,0,1,2.31,1,3,3,0,0,1,.83.85c.16.32.34.74.5,1.1l1.93,4.25c1.21,2.68,2.29,5.05,3.19,7.05h0l3.41,5c.39.56.7,1,.92,1.32l.24.33Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,274a53.11,53.11,0,0,0-.85-6.49,52.33,52.33,0,0,0-1.26-6.43,49.7,49.7,0,0,0,.84,6.5A50.74,50.74,0,0,0,382,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,231.87l2.59,32.65a2.13,2.13,0,0,0,2.26,2l18.2-1.18a2.14,2.14,0,0,0,2-2.32l-3-32.62a2.13,2.13,0,0,0-2.26-1.94l-17.81,1.16A2.14,2.14,0,0,0,322.54,231.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.5,273.44s-5.43,36.73-5.22,41.66,5.79,15.88,13.3,16.95,14.59-5.79,14.81-14.8,1.33-37.52,1.33-37.52l-5.61-3.09Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,275.6a1.73,1.73,0,0,0-.2.38c-.13.3-.28.66-.48,1.1-.4,1-1,2.35-1.79,4.05-1.54,3.41-3.86,8-6.25,13.22A94.27,94.27,0,0,0,296,308c-.27.9-.44,1.73-.62,2.45s-.3,1.36-.39,1.87-.15.87-.2,1.19-.06.42,0,.42a2.19,2.19,0,0,0,.12-.4c.08-.32.17-.7.28-1.17s.25-1.14.46-1.85.39-1.54.68-2.43a106.79,106.79,0,0,1,5.3-13.58c2.39-5.18,4.66-9.83,6.14-13.27.74-1.72,1.31-3.13,1.67-4.11l.4-1.14A1.85,1.85,0,0,0,309.88,275.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.45,243.09s-5.63,3.46-7.29,4.36-1.45,7.61-1.45,7.61l-9.46,22,11.41,4.09s4.06-7.7,5.23-8.67a7.85,7.85,0,0,1,2.73-1.36s.58,2.14,2.34,1.17a17.28,17.28,0,0,0,3.7-3.31s1.55,1,2.14-.2,1.56-3.7,1.56-3.7-3.32-4.28-4.68-4.28-8.37.39-8.37.39a5.38,5.38,0,0,1,2.34-1.37c1.94-.78,13.54-4.19,14.08-4.4.82-.31,1.74-2.44-.79-2.64s-16.8,2.35-16.8,2.35-.78-3.68-.19-4.46S329.59,246.59,327.45,243.09Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,268.81a3.59,3.59,0,0,0-.05-1.6,2.85,2.85,0,0,0-.85-1.58,3.29,3.29,0,0,0-2.1-.63,18.74,18.74,0,0,0-3.83.14,4.58,4.58,0,0,0-1.55.36c0,.13,2.41-.27,5.36-.08a3.12,3.12,0,0,1,1.86.51,2.71,2.71,0,0,1,.82,1.35A14.33,14.33,0,0,0,334.67,268.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.41,269.51c-.07-.09-1,.51-2.19,1a20.86,20.86,0,0,0-2.24.9,4.4,4.4,0,0,0,2.41-.52A4.31,4.31,0,0,0,332.41,269.51Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.79,255.06a3.69,3.69,0,0,0-3.07,3c.11,0,.5-.86,1.36-1.67S324.83,255.18,324.79,255.06Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.42,478.93c0,.15-96.45.26-215.41.26s-215.43-.11-215.43-.26,96.43-.26,215.43-.26S471.42,478.79,471.42,478.93Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksPana);
export default __webpack_public_path__ + "static/media/Bookmarks-pana.3339d369fc6ba4500e7174903b0199cd.svg";
export { ForwardRef as ReactComponent };